<template>
  <div class="notice-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>公告列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 整体布局：侧边栏 + 主内容 -->
    <el-container style="height: calc(100vh - 60px); position: relative;">
      <!-- 左侧导航栏 -->
      <el-aside width="220px" style="background: #fff; border-right: 1px solid #e6e6e6; position: relative; z-index: 10;">
        <!-- 导航菜单标题 -->
        <div class="menu-title">
          <i class="el-icon-s-unfold" style="margin-right: 8px;"></i>导航菜单
        </div>

        <!-- 导航菜单（绑定点击事件，传递type参数） -->
        <el-menu
            v-model="activeMenuIndex"
            mode="vertical"
            background-color="#fff"
            text-color="#333"
            active-text-color="#409EFF"
            style="border-right: none;"
            @select="handleMenuSelect"
        >
          <el-menu-item index="">
            <i class="el-icon-menu"></i>
            <span>全部</span>
          </el-menu-item>
          <el-menu-item index="1">
            <i class="el-icon-bell"></i>
            <span>动态资讯</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-trophy"></i>
            <span>竞赛通知</span>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="el-icon-document"></i>
            <span>赛事介绍</span>
          </el-menu-item>
          <el-menu-item index="0">
            <i class="el-icon-message"></i>
            <span>官方公告</span>
          </el-menu-item>
          <el-menu-item index="6" disabled>
            <i class="el-icon-download"></i>
            <span>软件下载</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <!-- 右侧主内容区 -->
      <el-main class="main-content">
        <!-- 顶部标签栏 + 排序（移除gutter，改用样式控制间距） -->
        <el-row class="top-operation-bar">
          <el-col>
            <div class="tag-group">
              <el-button
                  type="primary"
                  plain
                  :class="{ 'active-tag': currentTag === '' }"
                  @click="handleTagClick('')"
              >
                全部赛事
              </el-button>
              <el-button
                  type="default"
                  disabled
                  plain
                  :class="{ 'active-tag': currentTag === '白名单' }"
                  @click="handleTagClick('白名单')"
              >
                白名单
              </el-button>
              <el-button
                  type="default"
                  disabled
                  plain
                  :class="{ 'active-tag': currentTag === '热门竞赛' }"
                  @click="handleTagClick('热门竞赛')"
              >
                热门竞赛
              </el-button>
              <el-button
                  type="default"
                  disabled
                  plain
                  :class="{ 'active-tag': currentTag === '特色竞赛' }"
                  @click="handleTagClick('特色竞赛')"
              >
                特色竞赛
              </el-button>
            </div>
          </el-col>
          <el-col class="sort-col">
            <el-select v-model="sortType" placeholder="排序方式" style="width: 150px;" @change="handleSortChange">
              <el-option label="发布时间" value="publishTime"></el-option>
            </el-select>
          </el-col>
        </el-row>

        <!-- 列表加载状态 -->
        <!--        <el-loading :loading="loading" target=".notice-list-container" text="加载中..."></el-loading>-->

        <!-- 竞赛列表 -->
        <div class="notice-list-container" v-loading="loading" element-loading-text="拼命加载中"
             element-loading-spinner="el-icon-loading">
          <div
              v-for="(item, idx) in noticeList"
              :key="item.id"
              class="notice-item"
              @click="jumpDetails(item.id)"
          >
            <el-card shadow="hover" class="notice-card">
              <!-- 移除gutter，改用Flex布局+间距样式，移除span属性 -->
              <el-row type="flex" align="stretch">
                <!-- 左侧图片区域 - 改用Flex比例控制宽度 -->
                <el-col class="left-image-col">
                  <div class="image-wrapper">
                    <img
                        v-if="item.coverImageId"
                        :src="getImageUrl(item.coverImageId)"
                        alt="公告封面"
                        class="notice-image"
                        @error="(e) => handleImageError(e, idx)"
                    />
                    <!-- 无图片/图片加载失败时显示默认背景+标题 -->
                    <div v-else class="default-image bg-tech-animate">
                      <span class="default-title">{{ item.title }}</span>
                    </div>
                  </div>
                </el-col>

                <!-- 右侧内容区 - 自动填充剩余宽度 -->
                <el-col class="notice-content-col">
                  <!-- 右上角时间 -->
                  <div class="notice-time">
                    <i class="el-icon-time"></i>
                    <span>{{ item.createTime }}</span>
                  </div>
                  <el-tag :type="getTagType(item.tag)" class="notice-tag" size="small">{{
                      item.tag || '竞赛通知'
                    }}
                  </el-tag>
                  <h3 class="notice-title">{{ item.title }}</h3>
                  <p class="notice-desc">
                    {{ item.sketch || '暂无简介信息' }}
                  </p>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </div>

        <!-- 空状态提示 -->
        <div class="empty-state" v-if="noticeList.length === 0 && !loading">
          <el-empty description="暂无相关公告数据"></el-empty>
        </div>

        <!-- 分页 -->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            class="pagination"
            v-show="totalCount > 0"
        ></el-pagination>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {getNoticeInfo} from "@/api/index.js";
import global_variable from "@/utils/global_variable";

export default {
  name: 'NoticeList',
  data() {
    return {
      loading: false,
      noticeList: [],
      totalCount: 0,
      currentPage: 1, // 初始页码
      pageSize: 5,
      sortType: 'publishTime',
      activeMenuIndex: '', // 初始化为空，后续从缓存读取
      currentType: '', // 菜单类型
      currentTag: '', // 标签类型
      tagOptions: [
        {label: '全部赛事', value: ''},
        {label: '白名单', value: '白名单'},
        {label: '热门竞赛', value: '热门竞赛'},
        {label: '特色竞赛', value: '特色竞赛'}
      ]
    };
  },
  mounted() {
    // 防止页面滚动时出现抖动
    this.preventScrollJump();
    this.restoreOperationState(); // 初始化时恢复状态
    this.getInfo(); // 恢复状态后加载数据
  },
  updated() {
    // DOM更新后重新应用防滚动跳动逻辑
    this.$nextTick(() => {
      this.preventScrollJump();
    });
  },
  activated() {
    // 组件激活时重新应用防滚动跳动逻辑
    this.$nextTick(() => {
      this.preventScrollJump();
    });
  },
  methods: {
    // 原有方法不变：getImageUrl、handleImageError、getInfo、handleSizeChange、handleCurrentChange、handleSortChange
    getImageUrl(imageId) {
      if (!imageId) return '';
      // 生成原始 URL
      const originalUrl = `${global_variable.getProtocol()}//www.wancode.net:8585/wancode/back/image/read/${imageId}`;
      // 使用图片处理方法自动转换（HTTPS 环境下会转换为代理路径）
      return this.$processImages ? this.$processImages(originalUrl) : originalUrl;
    },

    handleImageError(e) {
      e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjgwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAgODAiPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCB3aWR0aD0iMTIwIiBoZWlnaHQ9IjgwIiByeD0iMTUiIGZpbGw9IiNmMGYwZjAiLz4KICAgIDxjaXJjbGUgY3g9IjYwIiBjeT0iNDAiIHI9IjE1IiBmaWxsPSIjZTBlMGUwIi8+CiAgICA8cGF0aCBkPSJNMzAgNjBDMjcgNjAgMjQgNTcgMjQgNTVWNDBDMjQgMzcgMjcgMzQgMzAgMzRINjBDNjMgMzQgNjYgMzcgNjYgNDJWMzNBNiA2IDAgMCAwIDYwIDI3SDMwYTYgNiAwIDAgMCAyNCAxNnYxM0MzMCA2MCAyNyA2MCAzMCA2MFoiIGZpbGw9IiM4ODgiLz4KICA8L2c+Cjwvc3ZnPg==';
    },

    getInfo() {
      this.loading = true;
      const param = {
        title: '',
        type: this.currentType,
        tag: this.currentTag,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        sortType: this.sortType
      };

      getNoticeInfo(param)
          .then(res => {
            if (res.code === "0000") {
              this.noticeList = res.data.list || [];
              this.totalCount = res.data.total || 0;
            } else {
              this.noticeList = [];
              this.totalCount = 0;
              this.$message.error('获取公告数据失败');
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请稍后重试');
            console.error('公告列表请求失败:', err);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.saveOperationState(); // 保存状态
      this.getInfo();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.saveOperationState(); // 保存状态
      this.getInfo();
    },

    handleSortChange() {
      this.currentPage = 1;
      this.saveOperationState(); // 保存状态
      this.getInfo();
    },

    handleMenuSelect(index) {
      this.loading = true;
      this.activeMenuIndex = index;
      this.currentType = index;
      this.currentPage = 1;
      this.saveOperationState(); // 保存状态
      this.getInfo();
    },

    handleTagClick(tag) {
      this.loading = true;
      this.currentTag = tag;
      this.currentPage = 1;
      this.saveOperationState(); // 保存状态
      this.getInfo();
    },

    jumpDetails(id) {
      if (!id) return;
      this.$router.push({
        path: '/noticeDetails',
        query: {id}
      });
      window.scrollTo(0, 0)
    },

    getTagType(tag) {
      const tagMap = {
        '紧急通知': 'danger',
        '重要通知': 'warning',
        '最新通知': 'success',
        '竞赛通知': 'primary',
        '动态资讯': 'info',
        '赛事介绍': 'purple',
        '官方公告': 'blue',
        '软件下载': 'green',
        '白名单': 'cyan',
        '热门竞赛': 'orange',
        '特色竞赛': 'pink'
      };
      return tagMap[tag] || 'default';
    },

    // ========== 新增：保存操作状态到localStorage ==========
    saveOperationState() {
      const state = {
        activeMenuIndex: this.activeMenuIndex,
        currentType: this.currentType,
        currentTag: this.currentTag,
        currentPage: this.currentPage,
        sortType: this.sortType,
        pageSize: this.pageSize
      };
      localStorage.setItem('noticeListOperationState', JSON.stringify(state));
    },

    // 防止页面滚动时出现抖动
    preventScrollJump() {
      // 获取主内容区域元素
      const mainContent = document.querySelector('.main-content');
      if (mainContent) {
        // 移除之前可能添加的事件监听器，防止重复绑定
        mainContent.removeEventListener('wheel', this._wheelHandler);
        
        // 定义滚轮事件处理函数
        this._wheelHandler = (e) => {
          // 阻止事件冒泡
          e.stopPropagation();
          
          // 如果内容高度小于容器高度，则不需要滚动
          if (mainContent.scrollHeight <= mainContent.clientHeight) {
            e.preventDefault();
            return;
          }
          
          // 计算滚动边界
          const scrollTop = mainContent.scrollTop;
          const scrollHeight = mainContent.scrollHeight;
          const clientHeight = mainContent.clientHeight;
          const deltaY = e.deltaY;
          
          // 到达顶部且试图向上滚动
          if (scrollTop === 0 && deltaY < 0) {
            e.preventDefault();
            return;
          }
          
          // 到达底部且试图向下滚动
          if (scrollTop + clientHeight >= scrollHeight && deltaY > 0) {
            e.preventDefault();
            return;
          }
        };
        
        // 监听滚轮事件，防止意外的页面移动
        mainContent.addEventListener('wheel', this._wheelHandler, { passive: false });
      }
    },
    
    // ========== 新增：从localStorage恢复操作状态 ==========
    restoreOperationState() {
      const stateStr = localStorage.getItem('noticeListOperationState');
      debugger
      if (stateStr) {

        const state = JSON.parse(stateStr);
        // 恢复所有状态字段
        this.activeMenuIndex = state.activeMenuIndex;
        this.currentType = state.currentType;
        this.currentTag = state.currentTag;
        this.currentPage = state.currentPage;
        this.sortType = state.sortType;
        this.pageSize = state.pageSize;
      } else {
        // 无缓存时设置默认值
        this.activeMenuIndex = '';
        this.currentType = '';
        this.currentTag = '';
        this.currentPage = 1;
        this.sortType = 'publishTime';
        this.pageSize = 5;
      }
    }
  },
  beforeUnmount() {
    // 清理事件监听器
    const mainContent = document.querySelector('.main-content');
    if (mainContent && this._wheelHandler) {
      mainContent.removeEventListener('wheel', this._wheelHandler);
    }
    this.saveOperationState(); // 组件销毁前保存状态（防止意外刷新）
  }
};
</script>

<style scoped>
.notice-page {
  width: 1200px;
  margin: 0 auto;
  text-align: left;
  /* 防止页面整体移动 */
  position: relative;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

.page-breadcrumb {
  margin: 15px 0;
  padding: 10px 16px;
  background: #fafafa;
  border-radius: 4px;
  cursor: pointer;
}

.menu-title {
  padding: 16px;
  font-size: 15px;
  font-weight: 500;
  color: #333;
  border-bottom: 1px solid #e6e6e6;
}

.main-content {
  padding: 16px;
  background: #f5f7fa;
  /* 明确设置滚动行为，防止整个区域移动 */
  overflow-y: overlay;
  position: relative;
  /* 防止鼠标悬停导致的意外移动 */
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  /* 确保内容区不会因为滚动而整体偏移 */
  will-change: scroll-position;
}

/* 隐藏滚动条样式 */
.main-content::-webkit-scrollbar {
  display: none;
}

.main-content {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 和 Edge */
}

.top-operation-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tag-group {
  display: flex;
  gap: 12px; /* 替代原gutter的间距 */
}

.sort-col {
  text-align: right;
}

/* 顶部标签栏选中态样式 */
.active-tag {
  background-color: #409EFF !important;
  color: #fff !important;
  border-color: #409EFF !important;
}

.notice-list-container {
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  /* 确保列表容器稳定 */
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  /* 防止硬件加速导致的渲染问题 */
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.notice-item {
  margin-bottom: 16px;
  cursor: pointer;
  transition: transform 0.2s ease;
}


/* 调整卡片高度，适应图片尺寸 */
.notice-card {
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  position: relative;
  /* 增加卡片稳定性 */
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

/* 左侧图片列 - 替代原span7的宽度（约29%） */
.left-image-col {
  width: 250px;
  height: 162px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
}

/* 右侧内容列 - 自动填充剩余宽度，添加左侧间距替代gutter */
.notice-content-col {
  flex: 1;
  margin-left: 20px; /* 替代原gutter的间距 */
  position: relative;
  padding: 12px 0;
}

.image-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  overflow: hidden;
  background-color: #f5f5f5;
}

/* 图片样式优化：宽高比更协调 */
.notice-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.notice-item:hover .notice-image {
  transform: scale(1.03);
}

.notice-time {
  position: absolute;
  top: 20px;
  right: 10px;
  font-size: 12px;
  color: #999;
}

.notice-tag {
  margin-top: 8px;
  margin-bottom: 8px;
}

.notice-title {
  font-size: 16px;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 20px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-desc {
  font-size: 13px;
  color: #666;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 60px;
}

.empty-state {
  margin: 60px 0;
  text-align: center;
}

.pagination {
  text-align: center;
  margin-top: 20px;
}

/* 修复图片错误状态样式 */
img[src=""] {
  opacity: 0;
}

/* 无图片时的默认背景样式 */
.default-image {
  width: 100%;
  height: 100%;
  background-size: 40%; /* 图标大小 */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

/* 渐变旋转动画 */
@keyframes gradientRotate {
  0% {
    --angle: 0deg;
  }
  100% {
    --angle: 360deg;
  }
}

/* 定义CSS变量（兼容） */
@property --angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

.bg-tech-animate {
  background: linear-gradient(var(--angle),
  #c4b5fd 0%,
  #3b82f6 50%,
  #8b5cf6 100%
  );
  background: -webkit-linear-gradient(var(--angle),
  #c4b5fd 0%,
  #3b82f6 50%,
  #8b5cf6 100%
  );
  /* 动画：渐变角度缓慢变化 */
  animation: gradientRotate 15s linear infinite;
}

/* 无图片时的标题样式 */
.default-title {
  font-size: 24px;
  color: white;
  text-align: center;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 最多显示3行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all; /* 中文换行 */
}
</style>
